import './../styles/Roadmap.css';

function IconCheck() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9" stroke="#2fe1c9" strokeWidth="1.8" />
      <path
        d="M8 12.5l2.5 2.5L16 9.5"
        stroke="#2fe1c9"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconPerson() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
        stroke="#2fe1c9"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 21a7.5 7.5 0 0 1 15 0"
        stroke="#2fe1c9"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconBars() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 19V13" stroke="#2fe1c9" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M12 19V9" stroke="#2fe1c9" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M19 19V5" stroke="#2fe1c9" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function IconRail() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6" cy="12" r="3" stroke="#2fe1c9" strokeWidth="1.8" />
      <circle cx="18" cy="12" r="3" stroke="#2fe1c9" strokeWidth="1.8" />
      <path d="M9 12h6" stroke="#2fe1c9" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

const PHASES = [
  {
    icon: IconCheck,
    title: 'The Check',
    description: 'Confirm both parties are permitted before anything settles.',
  },
  {
    icon: IconPerson,
    title: 'The Proof',
    description: 'Verifiable credentials, checked on-chain.',
  },
  {
    icon: IconBars,
    title: 'The Economics',
    description: 'Revenue from real network usage, reported in public.',
  },
  {
    icon: IconRail,
    title: 'Any Rail',
    description: 'The same check, on any chain or settlement rail.',
  },
];

export default function Roadmap() {
  return (
    <section className="roadmap">
      <div className="roadmap__header">
        <span className="roadmap__eyebrow">ROADMAP</span>
        <h2>
          What we're building, <span className="roadmap__highlight">phase by phase</span>.
        </h2>
      </div>

      <div className="roadmap__grid">
        {PHASES.map(({ icon: Icon, title, description }) => (
          <div className="roadmap-card" key={title}>
            <div className="roadmap-card__badge">
              <Icon />
            </div>
            <h3>{title}</h3>
            <p>{description}</p>
          </div>
        ))}
      </div>

      <div className="roadmap__cta">
        <a className="zq-btn zq-btn--solid zq-btn--lg" href="https://www.zilliqa.com/roadmap/">
          View the full roadmap →
        </a>
      </div>
    </section>
  );
}